import React from 'react';
import PropTypes from 'prop-types';

import { AdminHeader, AdminTitle, AdminViewIntegrations } from '../lib/admin_layout';
import Button, { ButtonTypes } from 'components/common/button';
import { H1 } from 'components/common/headers';
import connect from 'components/lib/connect';
import CreateApiToken from 'actions/api_tokens/create_api_token';

export function ApiTokensZeroState({ isAddPending, onClickNew }) {
  return (
    <AdminViewIntegrations className="apiTokens">
      <AdminHeader className="apiTokens-header">
        <AdminTitle>API Tokens</AdminTitle>
      </AdminHeader>
      {renderZeroState()}
    </AdminViewIntegrations>
  );

  function renderZeroState() {
    return (
      <div className="apiTokens-zero">
        {renderIcon()}
        {renderMessage()}
        {renderButton()}
      </div>
    );
  }

  function renderIcon() {
    return (
      <div className="apiTokens-zero-icon-container">
        {' '}
        <div className="apiTokens-zero-icon" />{' '}
      </div>
    );
  }

  function renderMessage() {
    return (
      <div className="apiTokens-zero-message">
        <H1 data-aid="apiTokens-zero-message-main">No API tokens have been created</H1>
        <div className="apiTokens-zero-message-detail">Get a token to integrate with our API</div>
      </div>
    );
  }

  function renderButton() {
    return (
      <div className="apiTokens-zero-addToken-container">
        <Button
          onClick={onClickNew}
          className="apiTokens-zero-addToken"
          disabled={isAddPending}
          buttonType={ButtonTypes.PRIMARY}
          data-aid="apiTokens-addToken"
        >
          Add Token
        </Button>
      </div>
    );
  }
}

ApiTokensZeroState.propTypes = {
  isAddPending: PropTypes.bool,
  onClickNew: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapExecuteToProps)(ApiTokensZeroState);

function mapStateToProps({ getProvider }) {
  return {
    isAddPending: getProvider('apiTokens').isPendingNew(),
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onClickNew: () => executeAction(CreateApiToken),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/api_tokens/api_tokens_zero_state.jsx